import React from "react";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { ToolButton } from "../../../../components";
import { hideAlert, showAlert } from "../../../../components/alert/Alert";
import { AlertTypeEnum } from "../../../../enums";
import { IToolButtonProps } from "../../../../interfaces";
import { roleDataService } from "../../services";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

export default function AddButton({ config }: IToolButtonProps) {
  const navigate = useNavigate();
  const { id: moduleId } = config;

  const handleClick = () => {
    const handleYes = async () => {
      const {
        data: { _id: newId }
      }: any = await roleDataService.create();

      hideAlert();
      navigate(`/${moduleId}/${newId}?mode=add`, { replace: false });
    };

    showAlert({
      content: "Are you sure you want to add a new role?",
      options: {
        actions: [
          { text: "No", onClick: hideAlert },
          { text: "Yes", onClick: handleYes, primary: true },
        ],
        type: AlertTypeEnum.Question,
      },
    });
  };

  return (
    <ToolButton
      text="Add"
      icon={faSquarePlus}
      primary
      raised
      onClick={handleClick}
      invalid={!securityService.checkRoleAccess(UserPermissions.editUserRoles)}
    />
  );
}
